import { SignIn } from '@clerk/clerk-react'
import './V2Auth.css'

/**
 * V2 login — delegates to Clerk's <SignIn /> component.
 *
 * Brand colors applied via Clerk's appearance API so the embedded form
 * matches the rest of /v2/*. See marteu-brand for the token values.
 */
const clerkAppearance = {
  variables: {
    colorPrimary: '#23201C',           // Into Space — primary button
    colorText: '#23201C',
    colorTextSecondary: '#8F432F',     // Caregiver Medium
    colorBackground: '#FFFFFF',
    colorInputBackground: '#F3F2ED',   // Bone
    colorInputText: '#23201C',
    fontFamily: 'Inter, system-ui, sans-serif',
    borderRadius: '6px'
  },
  elements: {
    card: { boxShadow: '0 2px 12px rgba(35,32,28,0.06)' },
    headerTitle: { fontFamily: 'Optima, Georgia, serif', fontWeight: 400 },
    formButtonPrimary: {
      background: '#23201C',
      '&:hover': { background: '#3a3530' }
    }
  }
}

export default function V2LoginPage() {
  return (
    <div className="v2-auth-page">
      <SignIn
        routing="hash"
        signUpUrl="/signup"
        appearance={clerkAppearance}
      />
    </div>
  )
}
